import { routeTo } from '../lib';

export function Logo({ light = false }: { light?: boolean }): JSX.Element {
  return <button className={`logo-mark ${light ? 'is-light' : ''}`} onClick={() => routeTo('/')} aria-label="MEMES home"><span className="logo-orb" /><span>MEMES</span></button>;
}
